import posthog from 'posthog-js';

posthog.init('phc_TJvqUZOQ74YCTFlpxzbc74ufLjYxiPwOaxHk0dWlW31', {
  api_host: 'https://us.i.posthog.com',
  autocapture: true,
  person_profiles: 'always',
  
});

export default posthog;